import BuyerPulseCheckCard from './BuyerPulseCheckCard.component';

export default BuyerPulseCheckCard;
